import StateContext from 'src/context/UserProvider';
import ErrorService, { EDPError } from "src/services/Error.service";

import IFunction from "src/components/container/Tree/CheckFunctions/Entity/Interface/IFunction";
import FunctionModel from "src/models/FunctionModel";

import ParserFunctions from "./pages/AuxParser/ParserListFunctions";

type FunctionServiceType = {
  getAllFunctions: () => Promise<IFunction[]>,
  getUserfunctions: (email: string, userId: number) => Promise<(string | number)[]>
}

/**
 * @class FunctionService
 */
const FunctionService = (): FunctionServiceType => {
  const { user } = StateContext();

  const getAllFunctions = async (): Promise<IFunction[]> => {
    const _userId: number | undefined = user?.id;
    const _email: string | undefined = user?.email;

    return new Promise((resolve, reject) => {
      if (_userId === undefined || _email === undefined) {
        reject("User login fail");
      }

      fetch(
        "/api/function/list",
        {
          credentials: 'include',
          headers: {
            contentType: "application/json; charset=utf-8",
            Accept: 'application/json',
            Authorization: `${_email}`,
            Validation: `${_userId}`
          }
        }
      ).then(
        response => {
          return (response.status === 200) ? response.json() : { data: [] }
        }
      ).then(
        (data: { data: any[] }) => {
          const lFnc: FunctionModel[] = [];
          data.data.forEach((value: any) => {
            lFnc.push(new FunctionModel(value));
          });
          return lFnc;
        }
      ).then(
        (lstFunc: FunctionModel[]) => {
          ParserFunctions(lstFunc).then(
            (data: IFunction[]) => resolve(data)
          ).catch(
            (err: any) => {
              ErrorService(
                new EDPError(
                  err.message ?? "Function.service - getAllFunctions",
                  "error",
                  undefined,
                  err.stack
                )
              );
              reject(err.message || "Error parse functions.");
            }
          )
        }
      ).catch(
        (err: any) => {
          ErrorService(
            new EDPError(
              err.message ?? "Function.service - getAllFunctions",
              "error",
              undefined,
              err.stack
            )
          );
          reject("List function is empty.");
        }
      );
    });
  }

  /**
   * @description Obtiene las funciones que tiene permisos el usuario.
   * @param {number} userId Identificador del usuario.
   * @returns {Promise<(string | number)[]>}
   */
  const getUserfunctions = async (email: string, userId: number): Promise<(string | number)[]> => {
    let _userId: number = user?.id || 0;
    let _email: string = user?.email || "";

    if (_userId === 0 && _email.trim().length === 0) {
      _userId = userId;
      _email = email;
    }

    let options = { }

    if (_userId !== userId && _email !== email) {
      const formdata = new FormData();
      formdata.append("bEmail", email);
      formdata.append("bUserID", `${userId}`);

      options = {
        method: "POST",
        body: formdata
      };
    }

    if (+userId > 0) {
      return new Promise((resolve, reject) => {

        if (_userId === null || _email === null || email === null || userId === null) {
          reject("No data find user");
        }

        fetch(
          '/api/function',
          {
            credentials: 'include',
            headers: {
              contentType: "application/json; charset=utf-8",
              Accept: 'application/json',
              Authorization: `${_email}`,
              Validation: `${_userId}`
            },
            ...options
          }
        ).then(
          response => {
            return (response.status === 200) ? response.json() : { data: []}
          }
        ).then(
          (data: { data: number[] }) => {
            (data.data.length >= 0) ? resolve(data.data) : resolve([-2]);
          }
        ).catch(
          (err: any) => {
            ErrorService(
              new EDPError(
                err.message ?? "Function.service - getUserfunctions",
                "error",
                undefined,
                err.stack
              )
            );
            reject("Get user function error.");
          }
        );
      });
    } else {
      return [];
    }
  }

  return {
    getAllFunctions,
    getUserfunctions
  }
}

export default FunctionService;
